import React, { createContext, useContext, useState, useEffect } from 'react';

const StaticContext = createContext();

export const StaticProvider = ({ children }) => {
    const [staticMode, setStaticMode] = useState(false);
    const [textMode, setTextMode] = useState(false);
    const [videoMode, setVideoMode] = useState(true); // Set to true by default
    const [awakeningMode, setAwakeningMode] = useState(false);
    const [videoMapping, setVideoMapping] = useState({
        1: '/suiba.mp4',
        2: '/doonies.mp4',
        3: '/tallys.mp4',
        4: '/awaken.mp4',
        5: '/aeon.mp4',
        6: '/egg.mp4',
        7: '/sweebs.mp4',
        8: '/citizen.mp4'
    });

    // Add video positions for easy editing
    const [videoPositions, setVideoPositions] = useState({
        1: { position: [0, 5.27, 0], scale: [3, 2] },          // Suiba - working reference
        2: { position: [-4.71, 5.25, 0], scale: [3, 2] },      // Doonies - working reference
        3: { position: [-0.1, 1.05, 0], scale: [3, 2] },       // Tallys - working reference
        4: { position: [-4.68, 1.1, 0], scale: [3, 2] },   // Yeti - DEBUG: large scale to find position
        5: { position: [-0.04, 5.20, 0], scale: [3, 2] },  // Sweebs - DEBUG: large scale to find position
        6: { position: [-0, 1.05, 0], scale: [3, 2] },   // Egg - DEBUG: large scale to find position
        7: { position: [-0.1, 0.9, 0], scale: [3, 2] },   // Aeon - DEBUG: large scale to find position
        8: { position: [0.02, 1.06, 0], scale: [3, 2] }    // Citizen - DEBUG: large scale to find position
    });

    // Handle awakening mode sequence
    useEffect(() => {
        let awakeningTimeout;
        let staticTimeout;

        if (awakeningMode) {
            // After 15 seconds of awakening mode, switch to static
            awakeningTimeout = setTimeout(() => {
                setStaticMode(true);
                setVideoMode(false);
                
                // After 5 seconds of static, reset everything
                staticTimeout = setTimeout(() => {
                    setStaticMode(false);
                    setAwakeningMode(false);
                    setVideoMode(true);
                    setTextMode(false);
                    if (window.screenColors) {
                        window.screenColors.clear();
                    }
                }, 5000);
            }, 15000);
        }

        return () => {
            if (awakeningTimeout) clearTimeout(awakeningTimeout);
            if (staticTimeout) clearTimeout(staticTimeout);
        };
    }, [awakeningMode]);

    return (
        <StaticContext.Provider value={{ 
            staticMode, 
            setStaticMode,
            textMode, 
            setTextMode,
            videoMode,
            setVideoMode,
            awakeningMode,
            setAwakeningMode,
            videoMapping,
            setVideoMapping,
            videoPositions,
            setVideoPositions
        }}>
            {children}
        </StaticContext.Provider>
    );
};

export const useStatic = () => {
    const context = useContext(StaticContext);
    if (context === undefined) {
        throw new Error('useStatic must be used within a StaticProvider');
    }
    return context;
}; 